module.exports = __webpack_public_path__ + "static/media/0007.27ccf5bf.jpg";